export default {
      id: "screenshot-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#screenshot",
      toString: function () {
        return this.url;
      }
    }